export const selectCheckList = state => state.checkList;
